import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import configureStore from 'redux/configureStore';
import App from './App';

import GlobalStyle from 'components/GlobalStyle';
import MainTheme from 'MainTheme';
import './components/GlobalStyle/CustomBootstrapStyles.scss';

const store = configureStore();

ReactDOM.render(
  <ThemeProvider theme={MainTheme}>
    <GlobalStyle />
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  </ThemeProvider>,
  document.getElementById('root')
);
